export default "__VITE_ASSET__Ch2a5StL__"